import React, {useEffect} from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FadeInWhenVisible from "../animations/FadeInWhenVisible";
import SupportContact from "../../pages/home/contact/ConTact";
import ScrollToTop from "../ui/ScrollTop";
import {ArrowUpOutlined} from "@ant-design/icons";
import {FloatButton} from "antd";
import Header from "./Header";

/**
 * The main layout component. It contains the navbar, the main content, and the
 * footer. It also includes a button to scroll to the top of the page.
 * @param {object} children The children elements to be rendered inside the
 * main content area.
 * @returns {ReactElement} The main layout element.
 */
const MainLayout = ({children}) => {
    return (
        <div className="flex flex-col min-h-screen">
            <FloatButton.BackTop/>
            {/*<div className="w-full h-16  hidden lg:block md:block">*/}
            {/*  <Header />*/}
            {/*</div>*/}
            {/* Navbar */}
            <Navbar/>
            {/* Main Content */}
            <main className="flex-grow ">{children}</main>
            {/* Footer */}
            <FadeInWhenVisible>
                <SupportContact/>
            </FadeInWhenVisible>
            <FadeInWhenVisible delay={0.1}>
                <Footer/>
            </FadeInWhenVisible>
        </div>
    );
};

export default MainLayout;
